<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_v"></a>Contents</h1>
<h2 class="toc-chapal"><a href="#/xhtml/04_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc"><a href="#/xhtml/05_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter1">Chapter 1: Jack the Ripper, 1888</a></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter2" title="Link target outside of Sample">Chapter 2: The Deptford Poisonings, 1885–89</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter3" title="Link target outside of Sample">Chapter 3: The Lambeth Poisoner, 1891–92</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter4" title="Link target outside of Sample">Chapter 4: The Southwark Poisoner, 1897–1902</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter5" title="Link target outside of Sample">Chapter 5: The Brides in the Bath, 1912–14</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter6" title="Link target outside of Sample">Chapter 6: The Black Out Ripper, 1942</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter7" title="Link target outside of Sample">Chapter 7: The Acid Bath Murders, 1944–49</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter8" title="Link target outside of Sample">Chapter 8: John Christie, 1943–53</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter9" title="Link target outside of Sample">Chapter 9: The Thames Nudes Murders, 1964–65</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter10" title="Link target outside of Sample">Chapter 10: Other serial killings? 1881–1948</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Conclusion" title="Link target outside of Sample">Conclusion</span></h2>
<h2 class="toc-chapal"><span href="#/xhtml/17_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="toc-chapal"><span href="#/xhtml/18_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?34f3df1a